import { render, staticRenderFns } from "./AdNotify.vue?vue&type=template&id=37bc6e7d&"
import script from "./AdNotify.vue?vue&type=script&lang=js&"
export * from "./AdNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports